export const officeStats = [
    {
        title: "Total Offices",
        value: 5,
        subtitle: "Across all locations",
        icon: "building",
        color: "#2563eb",
    },

    {
        title: "Active Offices",
        value: 4,
        subtitle: "Currently operational",
        icon: "checkCircle",
        color: "#10b981",
    },

    {
        title: "Employees",
        value: 142,
        subtitle: "Working across offices",
        icon: "users",
        color: "#8b5cf6",
    },

    {
        title: "Departments",
        value: 17,
        subtitle: "Distributed across branches",
        icon: "briefcase",
        color: "#f59e0b",
    },
];
